import { getAuth } from 'firebase/auth';

/**
 * Service pour créer un compte employé via la fonction Cloud avec CORS configuré
 * Cette fonction utilise l'admin SDK et ne connecte pas automatiquement l'utilisateur
 */
export const createEmployeeAccount = async (employeeData, tempPassword) => {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      throw new Error('Vous devez être connecté pour créer un employé');
    }

    // Récupérer le token d'authentification
    const idToken = await currentUser.getIdToken();

    // Préparer les données pour l'envoi
    const requestData = {
      email: employeeData.email,
      password: tempPassword,
      employeeData: {
        ...employeeData,
        tempPassword: tempPassword,
        needPasswordReset: true
      }
    };

    console.log('🔐 Envoi de la requête vers createEmployeeSimple...');
    console.log('📊 Données envoyées:', JSON.stringify(requestData, null, 2));

    // Utiliser une requête fetch directe vers la fonction Cloud avec CORS configuré
    const response = await fetch('https://europe-west1-omad-planning.cloudfunctions.net/createEmployeeSimple', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`
      },
      body: JSON.stringify(requestData)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Erreur lors de la création du compte');
    }

    const result = await response.json();
    console.log('✅ Compte employé créé avec succès via createEmployeeSimple:', result);

    return result;

  } catch (error) {
    console.error('❌ Erreur lors de la création du compte employé:', error);

    // Gérer les erreurs spécifiques
    if (error.message.includes('email-already-exists')) {
      throw new Error('Un compte avec cet email existe déjà');
    } else if (error.message.includes('invalid-email')) {
      throw new Error('Format d\'email invalide');
    } else if (error.message.includes('weak-password')) {
      throw new Error('Mot de passe trop faible');
    } else {
      throw new Error(error.message || 'Une erreur est survenue lors de la création du compte');
    }
  }
};

/**
 * Service pour supprimer complètement un intervenant via la fonction Cloud
 * Supprime le compte Firebase Auth et l'enregistrement Firestore
 */
export const deleteEmployeeAccount = async (employeeId) => {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      throw new Error('Vous devez être connecté pour supprimer un intervenant');
    }

    // Récupérer le token d'authentification
    const idToken = await currentUser.getIdToken();

    console.log('🗑️  Début de la suppression de l\'intervenant:', employeeId);

    // Utiliser une requête fetch directe vers la fonction Cloud avec CORS configuré
    const response = await fetch('https://europe-west1-omad-planning.cloudfunctions.net/deleteEmployeeAccount', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`
      },
      body: JSON.stringify({ employeeId })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Erreur lors de la suppression du compte');
    }

    const result = await response.json();
    console.log('✅ Intervenant supprimé avec succès via deleteEmployeeAccount:', result);

    return result;

  } catch (error) {
    console.error('❌ Erreur lors de la suppression de l\'intervenant:', error);

    // Gérer les erreurs spécifiques
    if (error.message.includes('Accès refusé')) {
      throw new Error('Permissions insuffisantes pour supprimer un intervenant');
    } else if (error.message.includes('Impossible de supprimer')) {
      throw new Error(error.message);
    } else if (error.message.includes('non trouvé')) {
      throw new Error('Intervenant non trouvé');
    } else {
      throw new Error(error.message || 'Une erreur est survenue lors de la suppression');
    }
  }
};
